import { TableCell, TableRow } from '@/common/components/ui/table';
import { useFormatCurrency } from '@/common/hooks/useFormatCurrency';
import { PolicyCoverage } from '@/policy/types/PolicyCoverage';

interface PolicyCoverageRowProps {
  coverage: PolicyCoverage;
  paddingLeft?: number;
}

export const PolicyCoverageRow = ({
  coverage,
  paddingLeft,
}: PolicyCoverageRowProps) => {
  const { formatCurrency } = useFormatCurrency();

  const tryFormatCurrency = (value: string) => {
    if (value.endsWith('%')) return value;

    return formatCurrency(value);
  };

  return (
    <TableRow className="bg-white even:bg-white">
      <TableCell
        className="border-r border-warm-gray-200 whitespace-normal w-[75cqw]"
        style={{ paddingLeft: `${paddingLeft}px` }}
      >
        {coverage.name}
      </TableCell>
      <TableCell className="border-r border-warm-gray-200">
        {coverage.form}
      </TableCell>
      <TableCell className="border-r border-warm-gray-200">
        {coverage.rp}
      </TableCell>
      <TableCell className="border-r border-warm-gray-200">
        {tryFormatCurrency(coverage.deductible)}
      </TableCell>
      <TableCell className="border-r border-warm-gray-200">
        {tryFormatCurrency(coverage.amount)}
      </TableCell>
      <TableCell>{coverage.premium}</TableCell>
    </TableRow>
  );
};
